import axios, { AxiosError, AxiosResponse } from "axios";

export const TRACK_HEADERS = { headers: { "track": true }}

const _axios = axios.create({
    baseURL: import.meta.env.VITE_URL_CAMPUS_API,

})

_axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }

        return config;
    },

    (error) => {
        Promise.reject(error);
    }
);

_axios.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => Promise.reject(error),
);

export default _axios